import React from "react";
import noop from "lodash/noop";
import { withTranslation } from "react-i18next";
import SvgIcon from "../SvgIcon";
import { RillContext } from "../../rill/RillReact/share/base";

class FileUpload extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modified: false,
      src: undefined,
      backgroundedit: undefined,
      nameFile: undefined,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleReset(e) {
    if (e && e.target && e.target.hasAttribute("data-noreset")) return;
    this.setState({
      src: undefined,
      modified: false,
      backgroundedit: undefined,
      nameFile: undefined,
    });
  }

  handleChange({ target }) {
    if (!target.value) {
      return false;
    } else {
      // extract file
      const file = target.files[0];

      // setup file reader
      const fileReader = new FileReader();

      // store the image in state once it's loaded off the file system
      fileReader.onload = (event) => {
        this.setState({
          src: event.target.result,
          modified: true,
          nameFile: file.name,
          backgroundedit: file.name.includes(".pdf")
            ? "/img/widget-icons/pdf-alt.svg"
            : file.name.includes(".xlsx") || file.name.includes(".docx")
            ? "/img/widget-icons/document-alt.svg"
            : "/img/widget-icons/image-alt.svg",
        });
        if (this.props.handleFileUpload) {
          this.props.handleFileUpload(event.target.result);
        }
      };

      // handle the error...kind of.
      fileReader.onerror = function (event) {
        console.error(
          "File could not be read! Code " + event.target.error.code
        );
      };

      // finally read the file
      fileReader.readAsDataURL(file);
    }
  }

  componentWillMount() {
    const fullImagePath = this.props.defaultValue
      ? `/api/file/${this.props.defaultValue}`
      : this.props.defaultValue;
    this.setState({
      src: fullImagePath,
      backgroundedit: this.props.backgroundedit,
    });
  }

  render() {
    const { locals } = this.context;
    const { t, name, raw, prefix, required = false, key } = this.props;
    const { modified, src, backgroundedit, nameFile } = this.state;
    const defaultValue = this.props.defaultValue || undefined;

    return (
      <div className="dashed-box">
        <label>
          <div className="add-new-file-div" style={{ cursor: "pointer" }}>
            {!backgroundedit && Object.keys(defaultValue).length === 0 ? (
              <div className="file-input">
                <SvgIcon
                  height={15}
                  width={15}
                  alt=""
                  src="/img/new-icons/upload-file.svg"
                />
                <p className="no-file">{t("uploadFilePdf")}</p>
              </div>
            ) : backgroundedit ? (
              <div className="file-input">
                <SvgIcon
                  height={15}
                  width={15}
                  alt=""
                  src="/img/new-icons/file-document.svg"
                />
                <p>{nameFile}</p>
              </div>
            ) : (
              // if we are going to edit
              <div className="file-input">
                {/* <img
                  height={15}
                  width={15}
                  alt=""
                  className="icon-green"
                  src="/img/svg/check.svg"
                /> */}
                <p>{defaultValue.name}</p>
              </div>
            )}
          </div>
          <input
            style={{ display: "none" }}
            key={defaultValue}
            ref="input"
            id="file-input"
            className="file-input"
            {...this.props}
            type="file"
            accept=".pdf"
            required={!defaultValue && this.props.required}
            onChange={this.handleChange}
            defaultValue={undefined}
          />
        </label>

        {!modified && defaultValue && (
          <input
            type="hidden"
            name={`${name}[file]`}
            value={defaultValue}
            onChange={noop}
          />
        )}
      </div>
    );
  }
}

FileUpload.defaultProps = {
  defaultValue: {},
};

FileUpload.contextType = RillContext;

export default withTranslation("common")(FileUpload);
